export function toSystemConfiguration(source) {
    return {
        maxcolumns: source.maxcolumns,
    };
}
//# sourceMappingURL=SystemConfiguration.js.map